import { useEffect, useState } from 'react';
import React from 'react';
export const Timer = () => {
  const [time, setTime] = useState(5 * 60);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds} นาที`;
  };

  return <span style={{ display: 'inline' }}>{formatTime(time)}</span>;
};
